import { render } from "./MemberBenefitsPopup.vue?vue&type=template&id=6f0f4e6e&scoped=true"
import script from "./MemberBenefitsPopup.vue?vue&type=script&lang=js"
export * from "./MemberBenefitsPopup.vue?vue&type=script&lang=js"

import "./MemberBenefitsPopup.vue?vue&type=style&index=0&id=6f0f4e6e&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0f4e6e"]])

export default __exports__